export type FeatureId = 
  | 'order_management'
  | 'user_management'
  | 'worker_management'
  | 'event_management'
  | 'category_management'
  | 'event_registrations'
  | 'track_management'
  | 'reports_analytics'
  | 'calendar_view'
  | 'email_templates'
  | 'system_settings'
  | 'customer_management';

export type UserRole = 'user' | 'worker' | 'admin' | 'driver' | 'promotor';

export interface Permission {
  id: string;
  role: string;
  feature_id: FeatureId;
  can_access: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface PermissionMap {
  [key: string]: boolean;
}

export interface Feature {
  id: FeatureId;
  name: string;
  description: string;
  default_access: {
    [K in UserRole]: boolean;
  };
}

export const FEATURES: Feature[] = [
  {
    id: 'order_management',
    name: 'Order Management',
    description: 'Manage track bookings and orders',
    default_access: {
      user: false,
      worker: true,
      admin: true,
      driver: false,
      promotor: false
    }
  },
  {
    id: 'user_management',
    name: 'User Management',
    description: 'Manage user accounts and profiles',
    default_access: {
      user: false,
      worker: false,
      admin: true,
      driver: false,
      promotor: false
    }
  },
  {
    id: 'worker_management',
    name: 'Worker Management',
    description: 'Manage worker accounts and permissions',
    default_access: {
      user: false,
      worker: false,
      admin: true,
      driver: false,
      promotor: false
    }
  },
  {
    id: 'event_management',
    name: 'Event Management',
    description: 'Create and manage racing events',
    default_access: {
      user: false,
      worker: true,
      admin: true,
      driver: false,
      promotor: true
    }
  },
  {
    id: 'category_management',
    name: 'Category Management',
    description: 'Manage event categories and classifications',
    default_access: {
      user: false,
      worker: true,
      admin: true,
      driver: false,
      promotor: false
    }
  },
  {
    id: 'event_registrations',
    name: 'Event Registrations',
    description: 'Manage event registrations and participants',
    default_access: {
      user: false,
      worker: true,
      admin: true,
      driver: false,
      promotor: true
    }
  },
  {
    id: 'track_management',
    name: 'Track Management',
    description: 'Manage track services and pricing',
    default_access: {
      user: false,
      worker: true,
      admin: true,
      driver: false,
      promotor: false
    }
  },
  {
    id: 'reports_analytics',
    name: 'Reports & Analytics',
    description: 'View reports and analytics data',
    default_access: {
      user: false,
      worker: true,
      admin: true,
      driver: false,
      promotor: false
    }
  },
  {
    id: 'calendar_view',
    name: 'Calendar View',
    description: 'Access calendar and scheduling features',
    default_access: {
      user: false,
      worker: true,
      admin: true,
      driver: false,
      promotor: true
    }
  },
  {
    id: 'email_templates',
    name: 'Email Templates',
    description: 'Manage email templates and communications',
    default_access: {
      user: false,
      worker: false,
      admin: true,
      driver: false,
      promotor: false
    }
  },
  {
    id: 'system_settings',
    name: 'System Settings',
    description: 'Configure system settings and preferences',
    default_access: {
      user: false,
      worker: false,
      admin: true,
      driver: false,
      promotor: false
    }
  },
  {
    id: 'customer_management',
    name: 'Customer Management',
    description: 'Manage customer relationships and data',
    default_access: {
      user: false,
      worker: true,
      admin: true,
      driver: false,
      promotor: false
    }
  }
];